<div mat-dialog-title>
  <div class="d-md-none my-3">
    <div class="d-flex justify-content-center">
      <div style="width: 79px;height: 5px; border-radius: 41px; background-color: #D9D9D9"></div>
    </div>
  </div>
  <div class="d-flex align-items-center">
    <img src="assets/imgs/icones/info-vermelho.svg" class="me-3">
    <span class="modal-title">Cancelar cotação</span>
  </div>
</div>

<div class="container-fluid h-100 overflow-hidden d-flex flex-column justify-content-between" >
  <form [formGroup]="model.asForm" (ngSubmit)="enviar()" class="scrollable-container-y">
    <div class="p-1">
      <div class="mb-2">
        <div class="mt-3">
          <span class="text-black">
          Você tem certeza de que deseja cancelar esta cotação? <br>
          <strong>Esta ação não pode ser desfeita.</strong> Se você cancelar,
          a cotação será removida do sistema e não poderá mais ser retomada
          </span>
        </div>
        <div class="mt-2">
          <app-input-select class="w-100" [label]="'Poderia nos dizer o motivo que deseja cancelar a proposta?'"
                            [id]="'mensagemId'" [tipoSelectNumber]="false" [placeholder]="''"
                            formControlName="mensagemId"
                            [invalid]="model.form.controls.mensagemId.invalid && !validarFormulario"
                            [list]="listaMotivos"></app-input-select>
        </div>
        <div class="mt-2">
          <div>
            <app-input-text-area [label]="'Observação (opcional)'"
                                 [rows]="3"
                                 [maxlength]="900"
                            [id]="'observacao'"
                            [placeholder]="'Por favor, informe mais detalhes da sua decisão'"
                            formControlName="observacao"
                             [required]="false"
                            [invalid]="model.form.controls.observacao.invalid && !validarFormulario"></app-input-text-area>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center mb-3">
      <div class="row">
        <div class="col-6">
          <button type="button" id="btnFecharDetalhes" class="btn btn-outline-secondary btn-sm w-100" (click)="fechar()">Voltar</button>
        </div>
        <div class="col-6">
          <button type="submit" id="btnCancelar" class="btn btn-danger btn-sm w-100">Cancelar cotação</button>
        </div>
      </div>
    </div>
  </form>
</div>
